import type { createSchoolModeApi } from './schoolModeApi';

import type { PublicApiKey } from '@/apilib';

export const SchoolModeApiKey: PublicApiKey<typeof createSchoolModeApi> = {
  name: 'SchoolModeApi',
  public: true,
};
